import { createFileRoute } from "@tanstack/react-router";

import CompletePasswordReset from "/src/routes/login/CompletePasswordReset";

// This URL is the token-bearing recovery link sent by the API. Keep it stable.
export const Route = createFileRoute("/resetPassword")({
  component: CompletePasswordReset,
});
